export default "__VITE_ASSET__DWJNBwCa__"